<template>
  <div class="no-drag">
    <div
      ref="modalRef"
      class="flex opacity-70 group-hover:opacity-100 text-14 py-5 px-10 rounded-8"
      :class="[
        {'opacity-100': menuIsOpen || isShowDropdown || show},
        !bookColor?.main ? isDarkMode ? 'hover:bg-sidebar' : 'hover:bg-project' : '',
        show && !bookColor?.main ? isDarkMode ? 'bg-sidebar' : 'bg-project' : ''
      ]"
      @click="showDropdown"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <slot>
        <i class="icon-supervisor-account text-20 mr-2" /> {{ book.shareWith?.length }}
      </slot>
    </div>

    <InviteModal ref="inviteModalRef" :book="book" />

    <InfoDropdown v-if="show" title="Shared with" class="relative" @show-dropdown="close">
      <div class="px-12 overflow-y-auto">
        <div v-for="(user, index) in members" :key="index" class="mb-4 text-15 flex items-center w-full">
          <span class="w-3 rounded-2 h-21 mr-10 block" :style="getColor(user.color)" />
          <div class="flex items-center justify-between w-full">
            <p>{{ user.firstName }}</p>
            <ButtonModule
              v-if="currentMember.id !== user.id"
              :has-hover="true"
              prefix="icon-delete text-main-color"
              class="text-app-color top-0 bottom-0 right-0 p-0"
              @click="deleteMember(user.id)"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <div class="border-b" :class="isDarkMode ? 'border-dark-900' : 'border-grey-400'" />

        <div class="hover:bg-selection rounded-b-4 relative pt-5 pb-8">
          <div class="flex items-center justify-center text-center text-15  cursor-pointer" @click="openInviteModal">
            <i class="icon-supervisor-account mr-3 text-main-color text-18" />
            <span class="mt-2">Add team member</span>
          </div>
        </div>
      </template>
    </InfoDropdown>
  </div>
</template>

<script>
import InfoDropdown from '@/components/shared/InfoDropdown'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import userColorMixin from '@/mixins/userColorMixin'
import { teamsService } from '@/services'
import InviteModal from '@/components/team/InviteModal'

export default defineComponent({
  components: { InfoDropdown, ButtonModule, InviteModal },

  props: {
    members: Array,
    book: Object,
    bookColor: Object,
    menuIsOpen: Boolean,
    isShowDropdown: Boolean
  },

  emits: ['showDropdown'],

  setup (props, { emit }) {
    const { getters, state, dispatch } = useStore()

    const modalRef = ref(null)
    const inviteModalRef = ref(null)

    const show = ref(false)
    const isHover = ref(false)

    const { getColor } = userColorMixin()

    const currentMember = computed(() => state.team.member)
    const isDarkMode = computed(() => getters.isDarkMode)

    function openInviteModal () {
      setTimeout(() => {
        inviteModalRef.value.open()
      }, 100)
    }

    function showDropdown () {
      setTimeout(() => {
        show.value = true
        emit('showDropdown', true)
      }, 100)
    }

    function close () {
      show.value = false
      modalRef.value.style = ''
      emit('showDropdown', false)
    }

    function deleteMember (id) {
      teamsService.removeMemberFromSpace({
        memberId: id,
        bookId: props.book.id
      })
        .then(() => dispatch('getBooks'))
    }

    function mouseenter (e) {
      if (props.bookColor?.accent) {
        modalRef.value.style = `background-color: ${props.bookColor.accent}; filter: brightness(0.93);`
      }
    }

    function mouseleave (e) {
      if (props.bookColor?.accent && !show.value) {
        modalRef.value.style = ''
      }
    }

    return {
      // refs
      modalRef,
      inviteModalRef,
      // data
      show,
      isHover,
      // computeds
      currentMember,
      isDarkMode,
      // functions
      getColor,
      openInviteModal,
      showDropdown,
      deleteMember,
      mouseenter,
      mouseleave,
      close
    }
  }
})
</script>
